import reducer from './reducers';
import * as patientsActions from './actions';
import * as patientsSelectors from './selectors';

export { patientsActions, patientsSelectors };
export default reducer;